import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useHistory } from "react-router-dom";

const ControlEditOrgaProfile = ({
  open,
  handleClose,
  handleConfirmEdit,
  isMobile,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={open}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: { padding: "40px 10px ", width: isMobile ? "100%" : "30%" },
        }}
      >
        <DialogTitle id="draggable-dialog-title" sx={{ margin: "0px 20px" }}>
          <Typography
            variant="title4"
            sx={{
              fontSize: "25px",
            }}
          >
            {t("are_you_sure")}?
          </Typography>
        </DialogTitle>{" "}
        <DialogContent sx={{ margin: "10px 20px" }}>
          <DialogContentText>
            <strong>{t("edit_orga_profile")}</strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions align="center">
          <Grid container>
            <Grid item xs={6}>
              <Button
                variant="outlined"
                color="deleteButton"
                sx={{ width: "90%" }}
                onClick={() => history.push("/quizzes/in_progress")}
              >
                {t("cancel")}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="error"
                sx={{ width: "90%" }}
                onClick={handleConfirmEdit}
              >
                {t("confirm")}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ControlEditOrgaProfile;
